








































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {deviceConfigurationProfile} from "@/components/device/configuration/AbeewayProfile";
import * as _ from "lodash";
import KeyValue from "@/components/KeyValue.vue";
import EditableSelect from "@/components/EditableSelect.vue";
import {curGroupService, GroupConfigurationParameter} from "@/services/GroupService";
import ExpandButton from '@/components/ExpandButton.vue';
import { ConfigurationProfileHelper } from './ConfigurationProfileHelper';

@Component({
  components: {
    KeyValue,
    EditableSelect,
    ExpandButton
  }
})
export default class AbeewayTrackingGroupConfiguration extends Vue {
  @Prop({ default: () => '', type: String}) group!:string;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  error:string = '';

  expanded:boolean = true;
  configurationProfileHelper = new ConfigurationProfileHelper(deviceConfigurationProfile);
  newConfiguration = this.configurationProfileHelper.getDeviceUIConfiguration();
  section = this.configurationProfileHelper.getUISections();

  isValueInRange(id:string):boolean {
    return this.configurationProfileHelper.isValueInRange(id, this.newConfiguration);
  }

  onPropertyChange(value: number, id:string) {
  }

  created() {
    this.$watch(() => this.newConfiguration["0x00"]!.value, (newValue, oldValue) => {
      this.onPropertyChange(newValue, '0x00');
    });
  }

  async mounted() {
    try {
      _.forEach(await this.loadGroupConfiguration(this.group), param => {
        if (this.newConfiguration[this.toHex(param.id)]) {
          this.newConfiguration[this.toHex(param.id)]!.value = param.value;
        }
      });
    } finally {
    }
  }

  async loadGroupConfiguration(groupId: string): Promise<GroupConfigurationParameter[]> {
    this.error = '';
    try {
      const configuration = await curGroupService.loadGroupConfiguration({
        groupId,
      }) as GroupConfigurationParameter[];
      return configuration;
    } catch (err) {
      this.error = (err as Error).message;
      return [];
    }
  }

  getIdsSortedByPosition():string[] {
    return this.configurationProfileHelper.getIdsSortedByPosition();
  }

  updateOption(id: string, value: string) {
    this.newConfiguration[id]!.value = value;
  }

  revertExtended(id: string) {
    this.section[this.configurationProfileHelper.deviceConfigurationProfile[id].sectionId as string].expanded
        = !this.section[this.configurationProfileHelper.deviceConfigurationProfile[id].sectionId as string].expanded;
  }

  async requestConfiguration() {
    this.error = '';
    try {
      await curGroupService.requestConfiguration({
        groupId: this.group,
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async updateConfiguration() {
    this.error = '';
    const formInvalid = _.some(_.keys(this.newConfiguration), id => ! this.isValueInRange(id));
    if (formInvalid) {
      this.error = 'Some values on the form are invalid. Please fix them before submitting !';
      return;
    }
    const paramKeysToUpdate = _.keys(this.newConfiguration);

    if (paramKeysToUpdate.length > 0) {
      const params = _.map(paramKeysToUpdate, key => _.pick(this.newConfiguration[key]!, 'id', 'value'));
      try {
        await curGroupService.sendConfiguration({
          groupId: this.group,
          command: 'set_configuration',
          params,
          updateConfiguration: true,
        });
        this.bus.$emit('refresh');
      } catch (err) {
        this.error = (err as Error).message;
      }
    }
  }

  async playMelody() {
    this.error = '';
    try {
      const queue = await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'play_melody',
        params: [{
          id: 0x00,
          value: 0x03,
        }],
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async triggerHeartbeatMessage() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'trigger_heartbeat_message',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async resetDevice() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'reset',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async setSOSOn() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'sos_mode_on',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async setSOSOff() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'sos_mode_off',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  async requestPosition() {
    this.error = '';
    try {
      await curGroupService.sendGroupCommand({
        groupId: this.group,
        command: 'request_position',
      });
      this.bus.$emit('refresh');
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  private toHex(d:number) {
    return  "0x" + ("0"+(d.toString(16))).slice(-2);
  }
}
